export const LANGUAGE_ITEM_CLICKED = 'wh.sports.event.ui.header.language-item.clicked';
export const FEATURE_TYPE = '@sportsbook/languages';
export const LANGUAGE_SELECTED = 'wh.common.event.ui.header.language.selected';
export const LANGUAGE_MENU_SHOW = 'wh.common.command.ui.header.language.menu.show';
export const LANGUAGE_MENU_HIDE = 'wh.common.command.ui.header.language.menu.hide';
